module.exports = __webpack_public_path__ + "images/812f041d2fba4aeef9cec5aff8625f28-50_badge.png";